import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate, getPastDate } from "../utils/formatTime";

const initialtextSearch = {
  facilityID: 0,
  msgKeyword: "",
  matchType: 2,
  fromDate: getPastDate(1),
  toDate: getCurrentDate(),
  sortBy: "",
  dateRangeType: 1,
}

// create slice
const name = "textSearch";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();



const slice = createSlice({
    name,
    initialState,
    reducers,
    extraReducers: (builder) => {
      createExtraReducers(builder);
    },
  });


// exports
export const textSearchAction = { ...slice.actions, ...extraActions };
export const textSearchReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
      textSearchdata : initialtextSearch,
     LoadTextSearchListFullList: [],
    };
}

  function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/TextSearch`;
    return {
      LoadTextSearchList: LoadTextSearchList(),  
    };

    function LoadTextSearchList() {
        return createAsyncThunk(
          `${name}/LoadTextSearchList`,
          async (params) => await fetchWrapper.post(`${baseUrl}/LoadTextSearchList`,params)
        );
      }
}

function createReducers() {
  return {
    cleartextSearchData,
    UpdateExcelResponse,
    settextSearch,
    cleartextSearch
  };

  function settextSearch(state, action) {
    state.textSearchdata = action && action.payload;
  }

  function cleartextSearch(state) {
    state.textSearchdata = initialtextSearch;
  }

  function cleartextSearchData(state) {
    state.LoadTextSearchListFullList = [];
  }

  function UpdateExcelResponse(state) {
    state.LoadTextSearchListFullList = [];
  }
}

function createExtraReducers(builder) {
    builder

    //LoadTextSearchList
    .addCase(extraActions.LoadTextSearchList.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(
        extraActions.LoadTextSearchList.fulfilled,
        (state, action) => {
          state.LoadTextSearchListFullList = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
      .addCase(extraActions.LoadTextSearchList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
      })
}